import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import { FormGroup, InputGroup, Button, Alert } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as s from './PreseasonRegistrationStep2.scss'
import RedHerringsPayPalButton from '../../Payment/RedHerringsPayPalButton'
import { teamRegistrationIsPaid, teamRegistrationRegisterTeam } from '@severed-links/common.redherrings-reducers/football'

const PreseasonRegistrationStep4 = forwardRef(({ jumpToStep }, _ref) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()
    const seasonName = params.seasonName || null
    const seasons = useSelector(state => state.football.seasons)
    const playerId = useSelector(state => state.account._id)
    const userName = useSelector(state => state.account.userName)
    const season = seasons.find(i => i.seasonName === seasonName)
    const seasonId = (season || {}).seasonId || null
    const teamRegistration = useSelector(state => state.football.teamRegistration)
    const preseason = useSelector(state => state.football.preseasons)[`${seasonId}`] || {}
    const { nflKickoff, spotsLeft, divisions, entryFee } = preseason
    const selectedDivision = teamRegistration.division || ''
    const hasValidDivision = Boolean(selectedDivision && (divisions || [])
        .some(i => i.value && `${i.value}` === `${selectedDivision}`))
    const _isValid = teamRegistration.isPaid || false
    const [showButton, setShowButton] = useState(false)
    const paymentEmail = useSelector(state => state.football.paymentEmail)

    const onAuthorizedFootballPayment = () => {
        if (!hasValidDivision) {
            jumpToStep(1)
            return
        }
        dispatch(teamRegistrationIsPaid(true))
        dispatch(teamRegistrationRegisterTeam({ seasonId, requestedTeamName: teamRegistration.teamName, requestedDivision: selectedDivision }))
        .then(action => {
            if (!action.error && (action.payload || {}).messageType !== 'error') jumpToStep(3)
        })
    }

    const onCancelledFootballPayment = () => {
        dispatch(teamRegistrationIsPaid(false))
        jumpToStep(1)
    }

    useImperativeHandle(_ref, () => ({
        isValidated: () => _isValid
    }))

    if (!hasValidDivision) {
        return (
            <div className={s.container}>
                <Alert variant='warning' className='mb-0'>
                    Select a division before continuing to payment.
                </Alert>
                <Button variant='primary' onClick={() => jumpToStep(1)}>
                    <FontAwesomeIcon name='chevron-left' /> Choose a division
                </Button>
            </div>
        )
    }

    return (
        <div className={s.container}>
            <div className={s.stepHeader}>
                <h3 className={s.stepTitle}>Complete registration</h3>
                <p className={s.stepDescription}>Submit the ${entryFee} entry fee to reserve your spot.</p>
            </div>
            <FormGroup className={s.formGroup}>
                <InputGroup>
                    <Button variant='light' onClick={() => jumpToStep(1)}><FontAwesomeIcon name='chevron-left' /> Back</Button>
                    <div className={s.paypalContainer}>
                        <RedHerringsPayPalButton
                            contest={'Football'}
                            itemNumber={playerId}
                            receiverEmail={paymentEmail}
                            description={'REDHERRINGS Football ' + seasonName}
                            amount={entryFee}
                            seasonId={seasonId}
                            playerId={playerId}
                            teamName={teamRegistration.teamName}
                            // TODO: CAN I GET new TeamId HERE??
                            onAuthorizedPayment={onAuthorizedFootballPayment}
                            onCancelledPayment={onCancelledFootballPayment} />
                    </div>
                </InputGroup>
            </FormGroup>
        </div>
    )
})

export default PreseasonRegistrationStep4
